import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { VanpoolsRoutingModule } from './vanpools-routing.module';
import { VanpoolsComponent } from './vanpools/vanpools.component';
import { SharedModule } from 'src/app/shared';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ConfigService, Util } from 'src/app/core';
import { VanpoolService } from 'src/app/core/services/vanpool.service';


@NgModule({
  declarations: [VanpoolsComponent],
  imports: [
    CommonModule,
    SharedModule,
    NgbModule,
    VanpoolsRoutingModule
  ],
  providers: [
    VanpoolService,
    ConfigService,
    Util
  ]
})
export class VanpoolsModule { }
